import { useReducedMotion } from "motion/react";

// Single gate for entrance/reveal animations. True when the user prefers
// reduced motion — and always true in the build-time prerender
// (import.meta.env.SSR): the static HTML must show final-state content,
// because crawlers read opacity-0 entrance frames as hidden text
// (scripts/prerender.mjs). Vite replaces `import.meta.env.SSR` statically,
// so the client bundle keeps the plain media-query behavior at no cost.
export function useRevealReducedMotion(): boolean {
  const prefersReduced = useReducedMotion();
  return import.meta.env.SSR || Boolean(prefersReduced);
}
